import { render, staticRenderFns } from "./EditCurrencyForm.vue?vue&type=template&id=140a4e77&"
import script from "./EditCurrencyForm.vue?vue&type=script&lang=js&"
export * from "./EditCurrencyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports